
import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ExpenseTypeSummaryReportService {

 constructor(private http: HttpClient) { }


  getWeekNoList(requestData:RequestData): Observable<any> {
      return this.http.post(environment.baseUrl+'/week-def/get',requestData);
  
    }

   
  getAreaList(): Observable<any>{  
    let search={"search":{"filters":{"column":[],"scope":{"limit":1000,"offset":0}},"sort": [{ column: "ca.name", order: "ASC" }]}};
    return this.http.post(environment.baseUrl+'/area/get', search);
  }
  

   exportExpenseReport(data: any): Observable<any> {
    // Add responseType: 'blob' to indicate you expect a binary response
    return this.http.post(
      environment.baseUrl+'/hq/reports/expense-type-summary-report', 
      data, 
      { responseType: 'blob' }
);
}


}
